import React from "react";
import "../styles.css";
import emailjs from "emailjs-com"

function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('service_kpex332', 'portfolio_template', e.target, 'user_Zrn6PxvtgZeb3j0dyNR0p')
        .then((result) => {
            console.log(result.text);
            <div id="success_message">
                <h3>Posted your message successfully!</h3>
            </div>
        }, (error) => {
            console.log(error.text);
            <div id="error_message"
            >
                <h3>Error</h3>
              Sorry there was an error sending your form.

  </div>
        });
    e.target.reset()
}

function ContactForm(props) {
    return (


        <div className="row ">
            <div className="col-md-10" id="form_container">
                <p className="intro">Contact Me</p>

                <p>
                    Send me a message, I'll get back to you at the earliest!
    </p>
                <form onSubmit={sendEmail}>

                    <div className="row ">
                        <div className="col-sm-12 form-group">
                            <textarea className="form-control" name="message" id="message" maxLength="6000" rows="5" defaultValue="Hi Rachael! "></textarea>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 form-group">
                            <label>
                                Your Name:</label>
                            <input type="text" className="form-control" id="name" name="name" required></input>
                        </div>
                        <div className="col-sm-6 form-group">
                            <label>
                                Email:</label>
                            <input type="email" className="form-control" id="email" name="email" required></input>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-sm-12 form-group">
                            <button type="submit" className="btn btn-lg btn-default pull-right" >Send →</button>
                        </div>
                    </div>

                </form>


            </div>
        </div>)
}

export default ContactForm;